import { createFileRoute, redirect } from '@tanstack/react-router';
import { api, ApiError, qk } from '@client/lib/api';

export interface Me {
  id: string;
  name: string;
  email: string;
  locale: 'en' | 'it';
  firm_id: string | null;
  title: string | null;
  preview: boolean;
  /** Reached the app only through a share link: there is no room or feed to navigate to. */
  share_only?: boolean;
  protections?: { hide_on_devtools: boolean };
}

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    try {
      const me = await context.queryClient.fetchQuery({ queryKey: qk.me, queryFn: () => api<Me>('/api/auth/me'), staleTime: 30_000 });
      return { me };
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) throw redirect({ to: '/login' });
      throw err;
    }
  },
  loader: () => {
    throw redirect({ to: '/rooms' });
  },
});
